var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.reviewOrder !== null
    ? _c(
        "form-button-disabler",
        { staticClass: "flex flex-col h-full" },
        [
          _c(
            "div",
            { staticClass: "grid grid-cols-3 border-b border-gray-500 w-full" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-span-3 flex border-b border-gray-500 px-3 pt-3 w-full",
                },
                [
                  _c("div", { staticClass: "flex text-xl" }, [
                    _vm._v("Order Details: "),
                    _c("div", { staticClass: "font-bold text-xl pl-2" }, [
                      _vm._v(_vm._s(_vm.orderTitle)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-grow" }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "mdi mdi-close mdi-24px font-bold cursor-pointer relative",
                    on: {
                      click: function ($event) {
                        return _vm.cancelProp()
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-span-3 flex border-b border-gray-500 px-3 w-full",
                },
                [
                  _c(
                    "div",
                    { staticClass: "grid grid-cols-2 pl-3 py-2 gap-y-1 w-3/6" },
                    [
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Client Ref ID")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.reviewOrder.clientRefId)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Price")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatString(_vm.reviewOrder.price, "n2")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Review Type")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.reviewOrder.reviewTypeName)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Final Due Date")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatString(
                                _vm.reviewOrder.finalDueDate,
                                "MM/dd/yyyy"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Vendor")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.reviewOrder.vendorName)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Package")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.packageName))]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Order Status")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.reviewOrder.currentStatus)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Buyer")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.buyerName))]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Product")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.reviewOrder.productName)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inline-text" }, [
                        _c("label", [_vm._v("Seller")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.sellerName))]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "note-text border-r border-l border-gray-500 p-2 w-1/5",
                    },
                    [
                      _c("label", [_vm._v("Notes")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.reviewOrder.notes))]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex w-2/5" }, [
                    _c(
                      "div",
                      { staticClass: "flex-grow note-text p-2 w-2/4" },
                      [
                        _c("label", [_vm._v("Instructions")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.reviewOrder.instructions)),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    (!_vm.hideEdit && _vm.hasEditPermissions) ||
                    (_vm.packageId !== null && _vm.hasExportPermission)
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col items-center justify-around",
                          },
                          [
                            !_vm.hideEdit && _vm.hasEditPermissions
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "btn",
                                      {
                                        staticClass: "w-44",
                                        attrs: { disabled: _vm.tabIndex !== 0 },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editReviewOrder()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-square-edit-outline",
                                        }),
                                        _vm._v(" Edit Order"),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasExportPermission
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "btn",
                                      {
                                        staticClass: "w-44",
                                        on: {
                                          click: function ($event) {
                                            return _vm.exportReviewOrder()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-microsoft-excel",
                                        }),
                                        _vm._v(" Export Order"),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "tabs",
            {
              staticClass: "flex-grow flex flex-col px-3 pr-4 pb-3",
              scopedSlots: _vm._u(
                [
                  {
                    key: "right-tab-menu",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "border-gray-500 p-3 font-bold text-xl",
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.formatString(_vm.orderCount, "n0")) +
                                " " +
                                _vm._s(
                                  _vm.pluralize(_vm.orderCount, "Loans", "Loan")
                                ) +
                                " in Order\n      "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                21349576
              ),
              model: {
                value: _vm.tabIndex,
                callback: function ($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex",
              },
            },
            [
              _vm._v(" "),
              _c(
                "tab",
                {
                  staticClass: "flex-grow flex flex-col",
                  attrs: { title: "Ordered" },
                },
                [
                  _c("full-screen-toggle", {
                    staticClass: "flex-grow flex flex-col",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (fullScreenSlotProps) {
                            return [
                              _c("ls-grid", {
                                staticClass: "w-full flex-grow",
                                attrs: {
                                  "defaults-key":
                                    "review-order-view-side-drawer:ordered",
                                  views: "",
                                  "auto-load": "",
                                  filters: "",
                                  groups: "",
                                  "column-filters": "",
                                  "as-of-date": "",
                                  "export-to-excel": "",
                                  "cut-copy-paste": "",
                                  expand: "",
                                  "adhoc-key-set":
                                    _vm.orderItems.length > 0
                                      ? _vm.orderItems.map((x) =>
                                          x.loanId.toString()
                                        )
                                      : ["-1"],
                                },
                                on: {
                                  fullscreen: function ($event) {
                                    return fullScreenSlotProps.onFullScreenToggle()
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2553104308
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "tab",
                {
                  staticClass: "flex-grow flex flex-col",
                  attrs: { title: "Received", disabled: !_vm.hasReceived },
                },
                [
                  _c("full-screen-toggle", {
                    staticClass: "flex-grow flex flex-col",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (fullScreenSlotProps) {
                            return [
                              _c("ls-grid", {
                                staticClass: "w-full flex-grow",
                                attrs: {
                                  "defaults-key":
                                    "review-order-view-side-drawer:received",
                                  views: "",
                                  "auto-load": "",
                                  filters: "",
                                  groups: "",
                                  "column-filters": "",
                                  "as-of-date": "",
                                  "export-to-excel": "",
                                  "cut-copy-paste": "",
                                  expand: "",
                                  "adhoc-key-set":
                                    _vm.receivedOrderItems.length > 0
                                      ? _vm.receivedOrderItems.map((x) =>
                                          x.loanId.toString()
                                        )
                                      : ["-1"],
                                },
                                on: {
                                  fullscreen: function ($event) {
                                    return fullScreenSlotProps.onFullScreenToggle()
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3212728756
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }